import React from 'react'
import PropTypes from 'prop-types'

import LanguageCardWithAvatarPlaceholder from 'src/ui/LanguageCardWithAvatar/LanguageCardWithAvatarPlaceholder'
import SelfAssessmentPlaceholder from 'src/pages/LearningLanguageLevelAssessment/subcomponents/SelfAssessment/SelfAssessmentPlaceholder'

const LevelAssessmentCardPlaceholder = ({ open }) => {
  return (
    <LanguageCardWithAvatarPlaceholder open={open}>
      {open ? <SelfAssessmentPlaceholder /> : null}
    </LanguageCardWithAvatarPlaceholder>
  )
}

LevelAssessmentCardPlaceholder.propTypes = {
  open: PropTypes.bool,
}

export default LevelAssessmentCardPlaceholder
